module.exports = __webpack_public_path__ + "c151844b17b4c48be255d1ad0f97f150.jpg";